import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Contract} from '../../model/Entities/Contract';
import {ContractState} from '../../model/Entities/ContractState';
import {environment} from '../../environments/environment';

@Component({
    selector: 'contract-state',
    templateUrl: './contract-state.component.html',
    styleUrls: ['./contract-state.component.scss']
})
export class ContractStateComponent implements OnInit, OnChanges {

    readonly contractStateClass: any = ContractState;

    @Input() contract: Contract;

    public states: any = [];
    eshopUrl: string;

    ngOnInit(): void {

        this.eshopUrl = environment.eshopAdmin;
        this.states = [
            {
                id: 'new',
                object: this.contractStateClass.new,
                name: 'nová',
            },
            {
                id: 'confirmed',
                object: this.contractStateClass.confirmed,
                name: 'potvrzená',
            },
            {
                id: 'dispatched',
                object: this.contractStateClass.dispatched,
                name: 'vydaná',
            },
            {
                id: 'prepared',
                object: this.contractStateClass.prepared,
                name: 'připravená',
            },
            {
                id: 'handed',
                object: this.contractStateClass.handed,
                name: 'předaná',
            }
            ,
            {
                id: 'picked',
                object: this.contractStateClass.picked,
                name: 'vyzved. řidič',
            }
            ,
            {
                id: 'returned',
                object: this.contractStateClass.returned,
                name: 'vrácená',
            }
            ,
            {
                id: 'canceled',
                object: this.contractStateClass.canceled,
                name: 'zrušená',
            },
            {
                id: 'in_dispatch',
                object: this.contractStateClass.in_dispatch,
                name: 'vydává se',
            },
            {
                id: 'waitingAccept',
                object: this.contractStateClass.waitingAccept,
                name: 'Příjímá se'
            },
            {
                id: 'received',
                object: this.contractStateClass.received,
                name: 'Přijmuto'
            }

        ]

    }


    ngOnChanges(changes: SimpleChanges): void {
    }


}


// WEBPACK FOOTER //
// /app/src/SharedModule/ContractStateComponent/contract-state.component.ts